import Skeleton from "react-loading-skeleton";
import { JSX } from "react";

const CART_PRODUCT_CARD_COUNT = 2;

export const CartBackLinkSkeleton = (): JSX.Element => (
    <Skeleton
        containerClassName="p-cart-page__back--skeleton"
        width={80}
        height={15}
        borderRadius={4}
    />
);

export const CartProductCardsSkeleton = (): JSX.Element => (
    <Skeleton
        containerClassName="p-cart-page__items p-cart-page__items--skeleton"
        height="18rem"
        borderRadius="0.8rem"
        count={CART_PRODUCT_CARD_COUNT}
    />
);

export const CartOrderSummarySkeleton = (): JSX.Element => (
    <div className="p-cart-page__order-summary-skeleton">
        <div className="p-cart-page__order-summary-skeleton__section">
            <Skeleton height="2.7rem" width="55%" borderRadius={4} />
        </div>
        <div className="p-cart-page__order-summary-skeleton__section">
            <Skeleton height="2.7rem" count={2} borderRadius={4} />
        </div>
        <div className="p-cart-page__order-summary-skeleton__section p-cart-page__order-summary-skeleton__section--footer">
            <Skeleton height="2.7rem" borderRadius={4} />
            <Skeleton height="4rem" borderRadius={8} />
        </div>
    </div>
);
